import { Card, CardContent } from "@/components/ui/card";
import { Play } from "lucide-react";
import { useSignedUrl } from "@/hooks/useSignedUrl";

interface Media {
  id: string;
  title: string;
  description: string | null;
  media_type: string;
  image_url: string;
  video_url: string | null;
  display_order: number;
  course_id: string | null;
  courses?: {
    title: string;
  };
}

interface BibleSchoolMediaItemProps {
  item: Media;
  description: string | null;
  onClick: () => void;
}

export const BibleSchoolMediaItem = ({ item, description, onClick }: BibleSchoolMediaItemProps) => {
  const { signedUrl, loading } = useSignedUrl('mission-photos', item.image_url);

  return (
    <Card
      className="overflow-hidden cursor-pointer hover:shadow-lg transition-shadow rounded-xl"
      onClick={onClick}
    >
      <div className="relative aspect-video">
        {loading ? (
          <div className="w-full h-full bg-muted animate-pulse" />
        ) : (
          <img
            src={signedUrl}
            alt={item.title}
            className="w-full h-full object-cover"
          />
        )}
        {item.media_type === "video" && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/30">
            <Play className="w-16 h-16 text-white" />
          </div>
        )}
      </div>
      <CardContent className="p-4">
        {description && (
          <p className="text-sm text-muted-foreground line-clamp-2 mb-2">
            {description}
          </p>
        )}
        {item.courses && (
          <p className="text-sm text-primary">
            Course: {item.courses.title}
          </p>
        )}
      </CardContent>
    </Card>
  );
};
